export const visit = (vm, at) => {
at({ "fi": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "Uusi viesti" } } } });
};